/**
 * Numeric wire values used by the current .NET write models. Keep these
 * separate from the public string names returned by the read endpoints.
 */
export var RegistrationContextWireType;
(function (RegistrationContextWireType) {
    RegistrationContextWireType[RegistrationContextWireType["ClientAssignment"] = 0] = "ClientAssignment";
    RegistrationContextWireType[RegistrationContextWireType["InternalDepartment"] = 1] = "InternalDepartment";
})(RegistrationContextWireType || (RegistrationContextWireType = {}));
export const toRegistrationContextWireType = (contextType) => contextType === 'ClientAssignment'
    ? RegistrationContextWireType.ClientAssignment
    : RegistrationContextWireType.InternalDepartment;
export const getRegistrationContextKey = (context) => `${context.contextType}:${context.contextId}`;
export const getRegistrationContextLabel = (context) => context.contextType === 'InternalDepartment'
    ? `Internal — ${context.displayName}`
    : `${context.displayName} · Client`;
